import Vue from 'vue';

const storedUserInfo = localStorage.getItem('userInfo');

const state = Vue.observable({
  token: localStorage.getItem('token') || '',
  refreshToken: localStorage.getItem('refreshToken') || '',
  isLoggedIn: !!localStorage.getItem('token'),
  isActivated: localStorage.getItem('isActivated') === 'true',
  userInfo: storedUserInfo ? JSON.parse(storedUserInfo) : null
});

export const authStore = {
  state,
  getToken() {
    return state.token;
  },
  isAuthenticated() {
    return state.isLoggedIn;
  },
  currentUser() {
    return state.userInfo;
  },
  login(token, refreshToken, userInfo, isActivated) {
    state.token = token || '';
    state.refreshToken = refreshToken || '';
    state.isLoggedIn = !!token;
    state.userInfo = userInfo || null;
    state.isActivated = !!isActivated;
    localStorage.setItem('token', state.token);
    localStorage.setItem('refreshToken', state.refreshToken);
    localStorage.setItem('userInfo', JSON.stringify(state.userInfo || null));
    localStorage.setItem('isActivated', String(state.isActivated));
  },
  clearLocal() {
    state.token = '';
    state.refreshToken = '';
    state.isLoggedIn = false;
    state.isActivated = false;
    state.userInfo = null;
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('isActivated');
    localStorage.removeItem('activationCode');
  },
  logout() {
    this.clearLocal();
  },
  setToken(newToken) {
    state.token = newToken || '';
    state.isLoggedIn = !!newToken;
    if (state.token) {
      localStorage.setItem('token', state.token);
    } else {
      localStorage.removeItem('token');
    }
  },
  setRefreshToken(newRefreshToken) {
    state.refreshToken = newRefreshToken || '';
    if (state.refreshToken) {
      localStorage.setItem('refreshToken', state.refreshToken);
    } else {
      localStorage.removeItem('refreshToken');
    }
  },
  setUserInfo(userInfo) {
    state.userInfo = userInfo || null;
    localStorage.setItem('userInfo', JSON.stringify(state.userInfo || null));
  },
  setActivated(activated) {
    state.isActivated = !!activated;
    localStorage.setItem('isActivated', String(state.isActivated));
  }
};
